<template>
	<el-dialog v-model="innerVisible" title="单据编辑" width="75%" custom-class="zero-padding-modal" append-to-body @opened="openedInit" @closed="closeDeal">
		<div class="assemble-choose-material-modal-content">
			<div class="" style="margin: 50px 100px 0px 100px;" >
				<el-form :model="queryParam" label-width="150px" ref="dialogformRef" :rules="Rules" >
					<el-row>
						<el-col :span="widthmd">
					  <el-form-item label="进货数量:" prop="restockQuantity">
					    <el-input-number min="0" v-model="queryParam.restockQuantity" clearable placeholder="请输入进货数量"  disabled/>
					  </el-form-item>
					</el-col>
						<el-col :span="widthmd">
                        <el-form-item label="生产日期:" prop="productionDate">
                            <el-date-picker v-model="queryParam.productionDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择生产日期" style="width: 100%" />
                        </el-form-item>
                    </el-col>					
					<el-col :span="widthmd">
						<el-form-item label="审核者:">
							<el-input v-model="queryParam.auditor" clearable placeholder="请输入审核者" />
						</el-form-item>
					</el-col>			
					<el-col :span="widthmd">
					  <el-form-item label="物料编号:">
					    <el-input v-model="queryParam.materialCode" clearable placeholder="请输入物料编号" disabled />
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
					  <el-form-item label="验收数量:" prop="acceptanceQuantity">
					    <el-input-number min="0" v-model="queryParam.acceptanceQuantity" clearable placeholder="请输入验收数量" />
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
                        <el-form-item label="验收日期:" prop="acceptanceDate">
                            <el-date-picker v-model="queryParam.acceptanceDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择验收日期" style="width: 100%" />
                        </el-form-item>
                    </el-col>
					<el-col :span="widthmd">
						<el-form-item label="主件品号:" prop="articleNumber">
							<el-input v-model="queryParam.articleNumber" clearable placeholder="请输入主件品号" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
					  <el-form-item label="采购单号:">
					    <el-input v-model="queryParam.purchaseNo" clearable placeholder="请输入采购单号" disabled/>
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="验退数量:" prop="returnQuantity">
							<el-input-number min="0" v-model="queryParam.returnQuantity" clearable placeholder="请输入验退数量" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
                        <el-form-item label="复检日期:" prop="recheckDate">
                            <el-date-picker v-model="queryParam.recheckDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择复检日期" style="width: 100%" />
                        </el-form-item>
                    </el-col>	
					<el-col :span="widthmd">
						<el-form-item label="折算率:">
							<el-input v-model="queryParam.conversionRate" clearable placeholder="请输入折算率" />
						</el-form-item>
					</el-col>	
					<el-col :span="widthmd">
					  <el-form-item label="批号:">
					    <el-input v-model="queryParam.batchNo" clearable placeholder="请输入库位编号" disabled/>
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
					  <el-form-item label="报废数量:" prop="scrapQuantity">
					    <el-input-number min="0" v-model="queryParam.scrapQuantity" clearable placeholder="请输入报废数量" />
					  </el-form-item>
					</el-col>				
					<el-col :span="widthmd">
						<el-form-item label="参数:">
							<el-input v-model="queryParam.parameter" clearable placeholder="请输入参数" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
                        <el-form-item label="有效日期:" prop="expirationDate">
                            <el-date-picker v-model="queryParam.expirationDate" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择有效日期" style="width: 100%" />
                        </el-form-item>
                    </el-col>
					<el-col :span="widthmd">
					  <el-form-item label="项目编号:">
					    <el-input v-model="queryParam.projectCode" clearable placeholder="请输入项目编号" disabled/>
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="破坏数量:" prop="destructionQuantity">
							<el-input-number min="0" v-model="queryParam.destructionQuantity" clearable placeholder="请输入破坏数量" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
					  <el-form-item label="仓库:" prop="warehouse">
					    <el-input v-model="queryParam.warehouse" clearable placeholder="请输入容器编号" disabled/>
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd"> 
					  <el-form-item label="ERP库位:" prop="locationCode">
						<el-select v-model="queryParam.locationCode" placeholder="请选择ERP库位" style="width: 100%;">
							<el-option v-for="item in selectOptions.locationData" :key="item.nI002" :label="item.nI002" :value="item.nI002" />
						</el-select>
					  </el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="采购单别:">
							<el-input v-model="queryParam.purchaseType" clearable placeholder="请输入采购单别"  disabled/>
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="赠备品验收数量:" prop="giftQuantity">
							<el-input-number min="0" v-model="queryParam.giftQuantity" clearable placeholder="请输入赠备品验收数量" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="扣款说明:">
							<el-input v-model="queryParam.deductMoneyRemark" clearable placeholder="请输入扣款说明" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="单位:">
							<el-input v-model="queryParam.unit" clearable placeholder="请输入单位" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="批号说明:">
							<el-input v-model="queryParam.batchNoRemark" clearable placeholder="请输入批号说明" />
						</el-form-item>
					</el-col>
					<el-col :span="widthmd">
						<el-form-item label="原币扣款金额:">
							<el-input-number min="0" v-model="queryParam.amount" clearable placeholder="请输入原币扣款金额" />
						</el-form-item>
					</el-col>
				</el-row>
				</el-form>
			</div>			
		</div>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="onBtnClose">取 消</el-button>
				<el-button  type="primary" @click="onOk">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script setup>
import { defineEmits, ref, reactive, watch, toRefs } from 'vue'	
import { ElMessage, ElMessageBox } from 'element-plus';
import { testockType ,department,location,page ,RestockOrderAdd,RestockOrderDelete} from '@/service/main/invoices/buildGoods'
//import { localStatus } from '../../switchCase'
const Rules = {
	warehouse: [{ required: true, message: '仓库不能为空', trigger: 'blur' }],
    restockQuantity: [{ required: true, message: '进货数量不能为空', trigger: 'blur' }],
    acceptanceQuantity: [{ required: true, message: '验收数量不能为空', trigger: 'blur' }],
    returnQuantity: [{ required: true, message: '退货数量不能为空', trigger: 'blur' }],
    scrapQuantity: [{ required: true, message: '报废数量不能为空', trigger: 'blur' }],
    destructionQuantity: [{ required: true, message: '破坏数量不能为空', trigger: 'blur' }],
    giftQuantity: [{ required: true, message: '赠备品验收数量不能为空', trigger: 'blur' }],
    locationCode: [{ required: true, message: 'ERP库位不能为空', trigger: 'blur' }],
    //articleNumber: [{ required: true, message: '主件品号不能为空', trigger: 'blur' }],
}
const widthmd = ref(5)
const pagination = {
	PageNo: 1,
	PageSize: 8
}
const emits = defineEmits(['update:visible','callback'])

const props = defineProps({
	editInfo:{
		type:Object,
		default:()=>{
			return {}
		}
	},
	visible:{
		type:Boolean,
		default:false
	}
})
const { visible,editInfo } = toRefs(props)
const innerVisible = ref(false)

const queryParam = ref({})
const queried = reactive({...pagination})
const selectOptions = reactive({
	testockTypeData:[],
	locationData:[],
})

watch(
	visible,
	function(newVal){
		if (innerVisible.value!==newVal) {
			innerVisible.value = newVal
		}
	},
	{immediate:true}
)
watch(innerVisible,function(newVal){
	if (visible.value!==newVal) {
		emits('update:visible',newVal)
	}
})

const closeDeal = function(){
	selfClose()
}

const onBtnClose = function(){
	selfClose()
}

const selfClose = function(){
	innerVisible.value = false
	emits('update:visible',innerVisible.value)
}

const openedInit = function(){
	getInfo()
	gettestockType()
	getlocation()
}

const getInfo = function(){
	queryParam.value = editInfo.value
}
const gettestockType = function(){
	if (selectOptions.testockTypeData.length<=0) {
		testockType().then((res) => {
			let arr = res.data || []
		  selectOptions.testockTypeData = arr
		})
	} 
}
const getlocation = function(){
	if (selectOptions.locationData.length<=0) {
		location({warehouse:queryParam.value.warehouse}).then((res) => {
			let arr = res.data || []
		  selectOptions.locationData = arr
		})
	} 
}

const handleSizeChange = function(pageSize){
	queried.PageNo = 1
	queried.PageSize = pageSize
}

const handleCurrentChange = function(page){
	queried.PageNo = page
}
const dialogformRef = ref()
const onOk = function(){
	const qty=Number(queryParam.value.acceptanceQuantity)+Number(queryParam.value.returnQuantity)+Number(queryParam.value.scrapQuantity)+Number(queryParam.value.destructionQuantity)+Number(queryParam.value.giftQuantity);
	if(qty>queryParam.value.restockQuantity)
	{
		//this.$message.error('进货数量不等于：验收数量+验退数量+报废数量+破坏数量+赠备品验收数量');
		ElMessage.error('进货数量不等于：验收数量+验退数量+报废数量+破坏数量+赠备品验收数量');
		return;
	}
	dialogformRef.value.validate((valid) => {
        if (valid) {
			selfClose()
			emits('callback',queryParam.value)
			//emits('editInfo',queryParam.value)
		}
    })
}

</script>

<style lang="less" scoped>
.assemble-choose-material-modal-content{
	height: 60vh;
	display: flex;
	flex-direction: column;
	.modal-content-top {
		padding: 20px 16px 0 16px;
		flex-shrink: 0;
	}
	.modal-content-list{
		flex-grow: 1;
		height: 1px;
		overflow: auto;
		.list-padding{
			padding: 0 16px;
		}
	}
}
</style>